import { useState, useEffect } from 'react';
import axios from 'axios';

// Fix-batch-4 #2 — single source of truth for the live MB list on the
// frontend. Reads /admin/mb-registry (same as BotConfigEditor) so a newly
// created MB (e.g. MB12) shows up everywhere automatically. Module-level
// cache (60s) keeps it cheap across the many places that need the list.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK = ['MB7', 'MB8', 'MB9', 'MB10', 'MB11'];

let _cache = null;
let _cacheAt = 0;
let _inflight = null;

export const fetchMBList = async (force = false) => {
  const now = Date.now();
  if (!force && _cache && now - _cacheAt < 60000) return _cache;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    try {
      let userId;
      try { userId = JSON.parse(localStorage.getItem('dws_user') || '{}').id; } catch { /* ignore */ }
      const res = await axios.get(`${API}/admin/mb-registry`, { params: userId ? { user_id: userId } : {} });
      let names = (res.data?.visible && res.data.visible.length)
        ? res.data.visible
        : (res.data?.items || []).filter((m) => !m.hidden).map((m) => m.name);
      names = (names || []).filter(Boolean);
      _cache = names.length ? names : FALLBACK;
      _cacheAt = Date.now();
      return _cache;
    } catch {
      return _cache || FALLBACK;
    } finally {
      _inflight = null;
    }
  })();
  return _inflight;
};

// Returns the live MB names (array). Starts from cache/fallback for an
// instant first paint, then updates once the registry resolves.
export const useMBList = () => {
  const [mbList, setMbList] = useState(_cache || FALLBACK);
  useEffect(() => {
    let alive = true;
    fetchMBList().then((names) => { if (alive) setMbList(names); });
    return () => { alive = false; };
  }, []);
  return mbList;
};

export default useMBList;
